import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {LoaderService} from 'src/app/service/loader.service';
import {TriagemService} from 'src/app/service/triagem.service';
import {UserService} from 'src/app/service/user.service';
import {RoutesEnum} from "../../shared/enums/routes.enum";
import {User} from "../../models/user.model";
import {ThemeService} from "../../service/theme.service";
import {StorageKeys} from "../../shared/enums/storage-keys.enum";

@Component({
  selector: 'app-from-falcon',
  templateUrl: './from-falcon.component.html',
  styleUrls: ['./from-falcon.component.scss']
})
export class FromFalconComponent implements OnInit {

  constructor(
    private loaderService: LoaderService,
    private route: Router,
    public themeService: ThemeService,
    private userService: UserService,
    private triagemService: TriagemService,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.loaderService.showLoader()
    const params = this.route.url.split('/') as any[];
    const token = params[2];
    const page = params[3];

    localStorage.setItem(StorageKeys.USER, decodeURIComponent(token));
    const decodedUser: User = this.userService.decrypt(StorageKeys.USER, true);
    console.log(decodedUser)

    this.userService.saveFromUserFalcon(decodedUser);
    if (decodedUser.contracts) {
      this.userService.setCurrentContract(decodedUser.contracts[0]);
    }
    const authToken = this.userService.getToken();
    if (authToken && page.includes('real-time')) {
      this.triagemService.loadContratosAndDomains();
      this.router.navigate([RoutesEnum.REAL_TIME])
      this.themeService.disableHeader();
      this.loaderService.hideLoader()
    }
  }

}
